import React from 'react';
import { Modal, Button, Divider } from 'rsuite';
import { List, ListItem, ListItemText } from '@mui/material';
import { WidgetDateTime } from '../../../../components';

export default function RechargeModal ({ show, onHide, recharge, transaction }) {
    // eslint-disable-next-line react/no-multi-comp
    const myTransaction = () => {
        return (
            <List>
                <ListItem>
                    <ListItemText primary='Id de transaccion' />{transaction.id}
                </ListItem>
                <ListItem>
                    <ListItemText primary='Id de transaccion padre' />{transaction.id_parent}
                </ListItem>
                <ListItem>
                    <ListItemText primary='Valor' />{transaction.amount}
                </ListItem>
                <ListItem>
                    <ListItemText primary='Descripcion' />{transaction.description}
                </ListItem>
                <ListItem>
                    <ListItemText primary='Creado' />{transaction.created_at ? (<WidgetDateTime date={new Date(transaction.created_at)} />) : ''}
                </ListItem>
                <ListItem>
                    <ListItemText primary='Estado' />{transaction.status.description}
                </ListItem>
                <ListItem>
                    <ListItemText primary='Tipo' />{transaction.type.description}
                </ListItem>
                <ListItem>
                    <ListItemText primary='Moneda' />{transaction.currency.description}
                </ListItem>
                <ListItem>
                    <ListItemText primary='Cuenta Origen' />{transaction.accounts.origin.id}
                </ListItem>
                <ListItem>
                    <ListItemText primary='Cuenta Destino' />{transaction.accounts.destination.id}
                </ListItem>
                {transaction.childs
                    ? transaction.childs.map(child => (
                        <List key={child.id}>
                            <ListItem>
                                <ListItemText primary='Cuenta Hijo id' />{child.id}
                            </ListItem>
                            <ListItem>
                                <ListItemText primary='Cuenta Hijo descripcion' />{child.description}
                            </ListItem>
                            {/* <ListItem>
                                <ListItemText primary='Cuenta Hijo tipo' />{child.type.description}
                            </ListItem> */}
                            <ListItem>
                                <ListItemText primary='Cuenta Hijo Valor' />{child.amount}
                            </ListItem>
                        </List>
                    )) : ''}
            </List>
        );
    };

    // eslint-disable-next-line no-unused-vars
    const spaceBetweenUpperCase = (word) => {
        return word.replace(/([a-z])([A-Z])/g, '$1 $2');
    };

    // eslint-disable-next-line react/no-multi-comp
    const doSubMetedata = (metadata) => {
        const metadataKeys = Object.keys(metadata);
        return (
            <List>
                {metadataKeys.map(key => {
                    if (typeof metadata[key] === 'string' || typeof metadata[key] === 'number') {
                        return (
                            <ListItem key={key}>
                                <ListItemText primary={`${key}`} />{metadata[key]}
                                {/* <ListItemText primary={`${spaceBetweenUpperCase(key)}`} />{metadata[key]} */}
                            </ListItem>
                        );
                    }
                    else {
                        return (
                            <ListItem key={key}>
                                <ListItemText primary={`${key}`} />
                                {/* <ListItemText primary={`${spaceBetweenUpperCase(key)}`} /> */}
                                {typeof metadata[key] === 'object' && doSubMetedata(metadata[key])}
                            </ListItem>
                        );
                    }
                })}
            </List>
        );
    };

    // Main Component
    return (
        <Modal
            open={show}
            onClose={onHide}
            className={`${show ? 'show in' : ''}`}
            aria-labelledby='recharge-view-modal'
        >
            <Modal.Header>
                <></>
            </Modal.Header>
            <Modal.Body>
                <h4>Detalle de Transaccion</h4>
                {transaction.id ? myTransaction() : ''}
                <Divider />
                <h4>
                    Detalle de Recarga
                </h4>
                {recharge.id ? (
                    <List>
                        <ListItem>
                            <ListItemText primary='Id de recarga' />{recharge.id}
                        </ListItem>
                        <ListItem>
                            <ListItemText primary='Id de cuenta de Origen' />{recharge.id_account_origin}
                        </ListItem>
                        <ListItem>
                            <ListItemText primary='Valor' />{recharge.amount}
                        </ListItem>
                        <ListItem>
                            <ListItemText primary='Destino' />{recharge.destination}
                        </ListItem>
                        <ListItem>
                            <ListItemText primary='Fecha de creacion' />
                            {/* {dateFns.format(new Date(recharge.created_at), 'dd/MM/yyyy HH:mm')} */}
                            <WidgetDateTime date={new Date(recharge.created_at)} />
                        </ListItem>
                        <ListItem>
                            <ListItemText primary='Fecha de Actualizado' />
                            {/* {dateFns.format(new Date(recharge.updated_at), 'dd/MM/yyyy HH:mm')} */}
                            <WidgetDateTime date={new Date(recharge.created_at)} />
                        </ListItem>
                        <ListItem>
                            <ListItemText primary='Id de transaccion externa' />{recharge.id_external_transaction}
                        </ListItem>
                        <ListItem>
                            <ListItemText primary='Id de producto' />{recharge.product.id}
                        </ListItem>
                        <ListItem>
                            <ListItemText primary='Estado' />{recharge.status.description}
                        </ListItem>
                        {doSubMetedata(recharge.metadata)}
                    </List>) : ''}
            </Modal.Body>
            <Modal.Footer>
                <div>
                    <Button appearance='primary' onClick={onHide} >Aceptar</Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}
